export const Events = {
    CONNECT: 'CONNECT',
    CONNECTION: 'CONNECTION',
    DISCONNECT: 'DISCONNECT',
    DISMISS_SYNC: 'DISMISS_SYNC',
    ERROR: 'ERROR',
    MESSAGE: 'MESSAGE',
    READY: 'READY',
    REGISTER: 'REGISTER',
    SEND_MESSAGE: 'SEND_MESSAGE',
    SET_AUTH_HEADER: 'SET_AUTH_HEADER',
    SET_HEADER: 'SET_HEADER',
    SET_URL: 'SET_URL',
    SET_VISIBILITY: 'SET_VISIBILITY',
    SUBSCRIBE: 'SUBSCRIBE',
    SUBSCRIBE_SYNC: 'SUBSCRIBE_SYNC',
    TEST_DISCONNECT: 'TEST_DISCONNECT',
    UNREGISTER: 'UNREGISTER',
    UNSUBSCRIBE: 'UNSUBSCRIBE',
    UNSUBSCRIBE_SYNC: 'UNSUBSCRIBE_SYNC'
};

export const States = {
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    DISCONNECTED: 'disconnected',
    DISCONNECTING: 'disconnecting'
};
